module.exports = __webpack_public_path__ + "img/logo-white-garage.e4d1f079.png";